import { addMessages } from '@hana/i18n';

// Khoá chuỗi của Vận tải (Ezy › TMS). Mã nghiệp vụ, biển số, tên riêng và dữ liệu không dịch.
addMessages('vi', {
  'rtform.add': 'Thêm tuyến',
  'rtform.subNew': 'Chuỗi điểm: depot / cảng → kho → cảng',
  'rtform.approved': 'Đã duyệt',
  'rtform.footRun': 'Đã chạy {n} chuyến',
  'rtform.footNew': 'Tuyến mới ở trạng thái NeedVerify',
  'rtform.deleted': 'Đã xoá {id}',
  'rtform.delete': 'Xoá tuyến',
  'rtform.saved': 'Đã lưu tuyến · NeedVerify',
  'rtform.route': 'Tuyến',
  'rtform.cargo': 'Loại hàng',
  'rtform.dp': 'Điểm lấy / hạ',
  'rtform.wh': 'Kho',
  'rtform.whErr': 'Chọn kho.',
  'rtform.shape': 'Hình tuyến',
  'rtform.kmHint': 'VietMap đề xuất theo đường xe tải',
  'rtform.time': 'Thời gian chạy',
  'rtform.timeNote': 'Tự tính từ GPS chuyến thực tế · không nhập tay',
  'rtform.avg': 'Trung bình',
  'rtform.range': 'Nhanh – chậm',
  'rtform.upd': 'Cập nhật',
  'rtform.est': 'Ước tính · VietMap',
  'rtform.afterWh': 'Sau khi chọn kho',
  'rtform.toGps': 'Chuyển sang GPS',
  'rtform.firstTrip': 'Từ chuyến đầu tiên',
  'rtform.restrict': 'Hạn chế xe tại kho',
  'rtform.tolls': 'Trạm thu phí cắt tuyến',
  'rtform.rescan': 'Quét lại',
  'rtform.scanned': 'Đã quét trạm theo đường đi · {n} trạm',
  'tlform.title': 'Trạm thu phí',
  'tlform.desc': 'Thêm hoặc sửa trạm · toạ độ đặt trên bản đồ · giá vé theo nhóm xe L1–L5.',
  'tlform.name': 'Tên trạm',
  'tlform.nameErr': 'Nhập tên trạm.',
  'tlform.sys': 'Hệ thống',
  'tlform.corr': 'Hành lang',
  'tlform.xy': 'Toạ độ',
  'tlform.xyBad': 'Sai toạ độ · nhập vĩ độ, kinh độ',
  'tlform.saved': 'Đã lưu trạm {name}',
  'plform.saved': 'Đã lưu {name}',
  'plform.savedDup': ' · ghi chú trùng {n} điểm',
  'plform.dupHint': 'Trùng trong 100 m: {list}',
  'plform.geoOk': 'Đã lấy vị trí máy · độ chính xác 12 m',
  'plform.xyHint': 'Dán link Google Maps / VietMap, lấy vị trí máy hoặc bấm trên bản đồ',
  'plform.addWh': 'Thêm kho khách',
  'plform.addDep': 'Thêm ICD / depot / cảng',
  'plform.sub': 'Toạ độ + geofence dùng cho bước GPS tự ghi của app tài xế',
  'plform.foot': 'Điểm mới / đổi toạ độ chờ Trưởng Vận tải duyệt',
  'plform.deleted': 'Đã xoá {name}',
  'plform.delete': 'Xoá',
  'plform.cancel': 'Huỷ',
  'plform.save': 'Lưu',
  'plform.whName': 'Tên kho',
  'plform.name': 'Tên',
  'plform.whNameErr': 'Nhập tên kho.',
  'plform.nameErr': 'Nhập tên.',
  'plform.whCode': 'Mã kho',
  'plform.code': 'Mã điểm',
  'plform.codeAuto': 'Mã tự sinh khi lưu',
  'plform.depotAuto': 'DepotCode tự sinh khi lưu',
  'plform.kind': 'Loại',
  'plform.address': 'Địa chỉ',
  'plform.area': 'Khu vực',
  'plform.whHours': 'Giờ nhận hàng',
  'plform.hours': 'Giờ hoạt động',
  'plform.newField': 'Trường mới',
  'plform.recvNote': 'Ghi chú nhận hàng',
  'plform.carriers': 'Hãng trả / lấy rỗng',
  'plform.carriersHint': 'Mã hãng · thêm /DC hoặc /RF nếu chỉ một loại',
  'plform.restrict': 'Hạn chế xe',
  'plform.ban': 'Giờ cấm tải',
  'plform.banBad': 'Sai khung · nhập hh:mm–hh:mm, cách nhau dấu phẩy',
  'plform.banN': '{n} khung',
  'plform.banMulti': 'Nhiều khung cách nhau dấu phẩy',
  'plform.ton': 'Tải trọng tối đa (tấn)',
  'plform.veh': 'Loại xe được vào',
  'plform.vehHint': 'Không chọn = mọi loại xe',
  'plform.road': 'Đường / khu cấm xe lớn',
  'plform.pos': 'Vị trí',
  'plform.xy': 'Toạ độ (vĩ độ, kinh độ)',
  'plform.radius': 'Bán kính geofence',
  'plform.dupAgain': '{n} điểm trong 100 m · bấm Lưu lần nữa để vẫn lưu',
  'plform.useGps': 'Lấy vị trí máy',
  'plform.fill': 'Điền địa chỉ từ toạ độ',
  'plform.reverse': 'Đã điền: P. Cát Lái, TP.HCM',
  'plform.gate': 'Cổng & tài khoản',
  'plform.eport': 'Link ePort',
  'plform.linked': 'đã có liên kết',
  'tms.noCustomer': 'Chưa gắn khách',
  'tms.address': 'Địa chỉ',
  'tms.ward': 'Phường / xã',
  'tms.unverified': 'chưa xác thực',
  'tms.kindRoute': 'Tuyến',
  'tms.kindToll': 'Trạm thu phí',
  'tms.approveRoute': 'Duyệt tuyến',
  'tms.priceTrf': 'Tính giá TRF',
  'tms.noToll': 'Chưa gắn trạm',
  'tms.lowConfWarn': 'Toạ độ tin cậy thấp · kiểm lại trước khi tính phí tuyến',
  'tms.noRouteForToll': 'Chưa có tuyến gắn trạm này',
  'tms.lowConf': 'tin cậy thấp',
  'tms.rp.runKm': 'Km chạy',
  'tms.rp.tierKm': 'Km tra bậc',
  'tms.rp.fuel': 'Dầu',
  'tms.rp.loadEmpty': 'Tải / rỗng',
  'tms.rp.vetcStations': 'Trạm VETC',
  'tms.handle': 'Tôi xử lý',
  'tms.filter': 'Lọc',
  'tms.mapLabel': 'Cát Lái · KCN Sóng Thần · ICD Phước Long',
  'tms.assign': 'Gán xe',
  'tms.dutyThanh': 'Đang trực: THANH · tới 17:30',
  'tms.createTrip': 'Tạo chuyến',
  'tms.lateVsPlan': 'Trễ so giờ hẹn',
  'tms.confirm': 'Xác nhận',
  'tms.costTrucking': 'Chi phí theo mảng Trucking',
  'tms.pending': 'Lệnh chờ gán',
  'tms.pendingHint': 'chọn rồi bấm tên xe trên lưới',
  'tms.pick': 'Chọn',
  'tms.today': 'Hôm nay',
  'tms.tomorrow': 'Ngày mai',
  'tms.onDuty': 'Đang trực: PhongNT',
  'tms.exceptions': 'Ngoại lệ · 5',
  'tms.ask': 'Hỏi Ask HANA',
  'tms.dutyNow': 'ĐANG TRỰC',
  'tms.dutyAdmin': 'Hành chính · tới 17:30',
  'tms.dutyNext': 'Kế tiếp: sáng sớm 06:00–08:00 thứ Sáu 23/Oct',
  'tms.otOct': 'OT tháng 10',
  'tms.swapShift': 'Xin đổi ca với PHONG',
  'tms.cutTrailer': 'Cắt mooc',
  'tms.swapTruck': 'Đổi xe',
  'tms.reeferPower': 'Cont lạnh mất điện',
  'tms.reeferDetail': 'TR-2610-0315 · 51C-903.55 · Trần Văn Hải · −18 → −14 °C. 15′ sẽ gọi PHONG.',
  'tms.callDriver': 'Gọi tài xế',
  'tms.iHandle': 'Tôi xử lý',
  'tms.viewOnlyAssign': 'Chỉ xem: không có quyền gán xe hay đổi chuyến.',
  'tms.clearFilter': 'Bỏ lọc',
  'tms.densityStd': 'Chuẩn',
  'tms.densityCompact': 'Gọn',
  'tms.viewOnly': 'Chỉ xem.',
  'tms.noRouteMatch': 'Không có tuyến khớp lọc',
  'tms.awaitApproval': 'chờ duyệt',
  'tms.noGps': 'thiếu GPS',
  'tms.priceExpiring': 'sắp hết hạn giá',
  'tms.addRoute': 'Thêm tuyến',
  'tms.fleetOverview': 'Tổng quan xe',
  'tms.activeVehicles': 'Xe hoạt động',
  'tms.tractors': 'đầu kéo',
  'tms.alerts': 'Cảnh báo · 5',
  'tms.vehicleList': 'Danh sách xe & mooc',
  'tms.fleetFoot': 'Điều xe PhongNT · GPS cập nhật 1 phút (adsun-proxy)',
  'tms.mapVehicles': 'Xe trên bản đồ · VietMap',
  'tms.catLai': 'Cát Lái',
  'tms.trungLuong': 'Trung Lương',
  'tms.vinhLong': 'Vĩnh Long',
  'tms.addVehicle': 'Thêm xe',
  'tms.placesMap': 'Bản đồ điểm & tuyến ›',
  'tms.edit': 'Sửa',
  'tms.copyCoords': 'Sao toạ độ',
  'tms.noCarrier': 'Chưa ghi hãng nào',
  'tms.coords': 'Toạ độ',
  'tms.area': 'Khu vực',
  'tms.province': 'Tỉnh',
  'tms.hours': 'Giờ hoạt động',
  'tms.ecus': 'Mã ECUS',
  'tms.open': 'Mở',
  'tms.noPlaceMatch': 'Không có điểm khớp lọc',
  'tms.addPlace': 'Thêm điểm',
  'tms.addToll': 'Thêm trạm',
  'tms.viewOnlyShort': 'Chỉ xem',
  'tms.ov.volume': 'Sản lượng chuyến · 14 ngày',
  'tms.ov.perDay': 'chuyến/ngày',
  'tms.ov.outside': 'nhà xe ngoài',
  'tms.ov.byProgress': 'Chuyến hôm nay theo tiến độ',
  'tms.ov.trips': 'chuyến',
  'tms.ov.onTime': 'Đúng giờ hôm nay',
  'tms.ov.todayTrips': 'Chuyến hôm nay · 22/Oct/2026',
  'tms.ov.thVehicle': 'Xe · tài xế',
  'tms.ov.thTrip': 'Chuyến · job',
  'tms.ov.thGps': 'Tiến độ GPS (7 bước)',
  'tms.ov.thDue': 'Hạn',
  'tms.ov.map': 'Bản đồ',
  'tms.ov.mapNote': 'VietMap · cập nhật 1 phút',
  'tms.ov.unassigned': 'Chưa gán xe',
  'tms.ov.notOpen': 'Mục này chưa mở',
  'tms.ov.noTripsToday': 'Chưa có chuyến hôm nay',
  'tms.ov.retry': 'Thử lại',
  'tms.ov.urgent': 'gấp',
  'tms.td.ownTruck': 'xe nhà',
  'tms.td.sameTruck': 'Cùng xe',
  'tms.td.finish': 'Finish lệnh',
  'tms.td.plan': 'Kế hoạch chuyến',
  'tms.td.stops': 'điểm',
  'tms.td.remind': 'Nhắc tài xế',
  'tms.td.runTime': 'Thời gian chạy',
  'tms.td.trackGps': 'Theo dõi GPS',
  'tms.td.mergeStop': 'Ghép điểm',
  'tms.td.earlyDrop': 'Xin hạ sớm / closing',
  'tms.td.idx': 'Chỉ số vận hành',
  'tms.td.calcOnFinish': 'tính khi Finish',
  'tms.td.logLeg': 'Ghi chặng',
  'tms.td.confirmAll': 'Xác nhận tất cả',
  'tms.td.thEvent': 'Sự kiện',
  'tms.td.thSource': 'Nguồn',
  'tms.td.phasePhotos': 'Ảnh theo pha',
  'tms.td.photo': 'Ảnh',
  'tms.td.movePhase': 'Chuyển pha',
  'tms.td.sendAll': 'Gửi tất cả cho tài xế',
  'tms.td.exportCsv': 'Xuất CSV',
  'tms.td.askJob': 'Hỏi nhóm job',
  'tms.td.needConfirm': 'cần xác nhận',
  'tms.td.depotLimit': 'Hạn chế kho',
  'tms.td.call': 'Gọi',
  'tms.td.back': 'Về điều độ',
  'tms.rp.viewAs': 'Xem như',
  'tms.rp.save': 'Lưu giá',
  'tms.rp.inputs': 'Đầu vào',
  'tms.rp.cargo': 'Loại hàng',
  'tms.rp.shape': 'Kiểu tuyến',
  'tms.rp.addStop': 'Thêm điểm giao',
  'tms.rp.km': 'Km tuyến',
  'tms.rp.kmBad': 'Nhập số km > 0',
  'tms.rp.empty': 'Tỉ lệ rỗng',
  'tms.rp.thStation': 'Trạm',
  'tms.rp.thSys': 'Hệ',
  'tms.rp.thPass': 'Lượt',
  'tms.rp.vetcTot': 'Tổng VETC',
  'tms.rp.table': 'Bảng tra đang áp',
  'tms.rp.result': 'Kết quả',
  'tms.rp.explain': 'Giải thích giá',
  'tms.rp.totalCost': 'Tổng chi phí',
  'tms.rp.extraStop': 'Điểm chen',
  'tms.rp.noMoney': 'Không có quyền xem tiền.',
  'tms.rp.noTrf': 'Không có quyền xem giá TRF.',
  'tms.rp.pickRoute': 'Chọn tuyến',
  'tms.rp.close': 'Đóng',
  'tms.rp.ticketL5': 'Vé lượt L5',
  'tms.rp.amount': 'Thành tiền',
  'tms.rp.vetcTariff': 'Biểu phí VETC 10/2026',
});

addMessages('en', {
  'rtform.add': 'Add route',
  'rtform.subNew': 'Stop chain: depot / port → warehouse → port',
  'rtform.approved': 'Approved',
  'rtform.footRun': '{n} trips run',
  'rtform.footNew': 'New routes start as NeedVerify',
  'rtform.deleted': 'Deleted {id}',
  'rtform.delete': 'Delete route',
  'rtform.saved': 'Route saved · NeedVerify',
  'rtform.route': 'Route',
  'rtform.cargo': 'Cargo type',
  'rtform.dp': 'Pickup / drop point',
  'rtform.wh': 'Warehouse',
  'rtform.whErr': 'Pick a warehouse.',
  'rtform.shape': 'Route shape',
  'rtform.kmHint': 'VietMap suggestion for truck roads',
  'rtform.time': 'Run time',
  'rtform.timeNote': 'Computed from real trip GPS · not typed',
  'rtform.avg': 'Average',
  'rtform.range': 'Fastest – slowest',
  'rtform.upd': 'Updated',
  'rtform.est': 'Estimate · VietMap',
  'rtform.afterWh': 'After picking a warehouse',
  'rtform.toGps': 'Switch to GPS',
  'rtform.firstTrip': 'From the first trip',
  'rtform.restrict': 'Warehouse vehicle limits',
  'rtform.tolls': 'Toll stations on route',
  'rtform.rescan': 'Rescan',
  'rtform.scanned': 'Scanned stations along the path · {n}',
  'tlform.title': 'Toll station',
  'tlform.desc': 'Add or edit a station · coordinates set on the map.',
  'tlform.name': 'Station name',
  'tlform.nameErr': 'Enter a station name.',
  'tlform.sys': 'System',
  'tlform.corr': 'Corridor',
  'tlform.xy': 'Coordinates',
  'tlform.xyBad': 'Bad coordinates · enter lat, lng',
  'tlform.saved': 'Saved station {name}',
  'plform.saved': 'Saved {name}',
  'plform.savedDup': ' · duplicate noted for {n} places',
  'plform.dupHint': 'Within 100 m: {list}',
  'plform.geoOk': 'Device location taken · accuracy 12 m',
  'plform.xyHint': 'Paste a Google Maps / VietMap link, use device location or click the map',
  'plform.addWh': 'Add customer warehouse',
  'plform.addDep': 'Add ICD / depot / port',
  'plform.sub': 'Coordinates + geofence drive the driver app GPS steps',
  'plform.foot': 'New points / moved coordinates await approval',
  'plform.deleted': 'Deleted {name}',
  'plform.delete': 'Delete',
  'plform.cancel': 'Cancel',
  'plform.save': 'Save',
  'plform.whName': 'Warehouse name',
  'plform.name': 'Name',
  'plform.whNameErr': 'Enter a warehouse name.',
  'plform.nameErr': 'Enter a name.',
  'plform.whCode': 'Warehouse code',
  'plform.code': 'Point code',
  'plform.codeAuto': 'Generated on save',
  'plform.depotAuto': 'DepotCode generated on save',
  'plform.kind': 'Type',
  'plform.address': 'Address',
  'plform.area': 'Area',
  'plform.whHours': 'Receiving hours',
  'plform.hours': 'Operating hours',
  'plform.newField': 'New field',
  'plform.recvNote': 'Receiving note',
  'plform.carriers': 'Empty return / pick-up lines',
  'plform.carriersHint': 'Line code · add /DC or /RF for one type only',
  'plform.restrict': 'Vehicle restrictions',
  'plform.ban': 'Truck ban hours',
  'plform.banBad': 'Invalid range · use hh:mm–hh:mm, comma separated',
  'plform.banN': '{n} ranges',
  'plform.banMulti': 'Several ranges, comma separated',
  'plform.ton': 'Max load (tons)',
  'plform.veh': 'Allowed vehicles',
  'plform.vehHint': 'None selected = all vehicles',
  'plform.road': 'Road / large-truck ban area',
  'plform.pos': 'Location',
  'plform.xy': 'Coordinates (lat, lng)',
  'plform.radius': 'Geofence radius',
  'plform.dupAgain': '{n} places within 100 m · press Save again to keep',
  'plform.useGps': 'Use device location',
  'plform.fill': 'Fill address from coordinates',
  'plform.reverse': 'Filled: Cat Lai Ward, HCMC',
  'plform.gate': 'Gate & account',
  'plform.eport': 'ePort link',
  'plform.linked': 'linked',
  'tms.noCustomer': 'No customer linked',
  'tms.address': 'Address',
  'tms.ward': 'Ward',
  'tms.unverified': 'unverified',
  'tms.kindRoute': 'Routes',
  'tms.kindToll': 'Toll stations',
  'tms.approveRoute': 'Approve route',
  'tms.priceTrf': 'Price TRF',
  'tms.noToll': 'No toll station linked',
  'tms.lowConfWarn': 'Low-confidence coordinates · recheck before pricing the route',
  'tms.noRouteForToll': 'No route linked to this station',
  'tms.lowConf': 'low confidence',
  'tms.rp.runKm': 'Run km',
  'tms.rp.tierKm': 'Tier km',
  'tms.rp.fuel': 'Fuel',
  'tms.rp.loadEmpty': 'Loaded / empty',
  'tms.rp.vetcStations': 'VETC stations',
  'tms.handle': 'I\'ll handle it',
  'tms.filter': 'Filter',
  'tms.mapLabel': 'Cát Lái · Sóng Thần IP · Phước Long ICD',
  'tms.assign': 'Assign vehicle',
  'tms.dutyThanh': 'On duty: THANH · until 17:30',
  'tms.createTrip': 'Create trip',
  'tms.lateVsPlan': 'Late vs. scheduled time',
  'tms.confirm': 'Confirm',
  'tms.costTrucking': 'Costs by Trucking segment',
  'tms.pending': 'Orders awaiting assignment',
  'tms.pendingHint': 'pick one, then tap a vehicle on the grid',
  'tms.pick': 'Pick',
  'tms.today': 'Today',
  'tms.tomorrow': 'Tomorrow',
  'tms.onDuty': 'On duty: PhongNT',
  'tms.exceptions': 'Exceptions · 5',
  'tms.ask': 'Ask HANA',
  'tms.dutyNow': 'ON DUTY',
  'tms.dutyAdmin': 'Office hours · until 17:30',
  'tms.dutyNext': 'Next: early shift 06:00–08:00 Friday 23/Oct',
  'tms.otOct': 'OT for October',
  'tms.swapShift': 'Request a shift swap with PHONG',
  'tms.cutTrailer': 'Cut trailer',
  'tms.swapTruck': 'Swap vehicle',
  'tms.reeferPower': 'Reefer container lost power',
  'tms.reeferDetail': 'TR-2610-0315 · 51C-903.55 · Trần Văn Hải · −18 → −14 °C. PHONG will be called in 15′.',
  'tms.callDriver': 'Call driver',
  'tms.iHandle': 'I\'ll handle it',
  'tms.viewOnlyAssign': 'View only: no permission to assign vehicles or change trips.',
  'tms.clearFilter': 'Clear filters',
  'tms.densityStd': 'Standard',
  'tms.densityCompact': 'Compact',
  'tms.viewOnly': 'View only.',
  'tms.noRouteMatch': 'No routes match the filter',
  'tms.awaitApproval': 'pending approval',
  'tms.noGps': 'missing GPS',
  'tms.priceExpiring': 'price expiring',
  'tms.addRoute': 'Add route',
  'tms.fleetOverview': 'Fleet overview',
  'tms.activeVehicles': 'Active vehicles',
  'tms.tractors': 'tractors',
  'tms.alerts': 'Alerts · 5',
  'tms.vehicleList': 'Vehicles & trailers',
  'tms.fleetFoot': 'Dispatch PhongNT · GPS refreshes every 1 min (adsun-proxy)',
  'tms.mapVehicles': 'Vehicles on map · VietMap',
  'tms.catLai': 'Cát Lái',
  'tms.trungLuong': 'Trung Lương',
  'tms.vinhLong': 'Vĩnh Long',
  'tms.addVehicle': 'Add vehicle',
  'tms.placesMap': 'Places & routes map ›',
  'tms.edit': 'Edit',
  'tms.copyCoords': 'Copy coordinates',
  'tms.noCarrier': 'No carrier recorded',
  'tms.coords': 'Coordinates',
  'tms.area': 'Area',
  'tms.province': 'Province',
  'tms.hours': 'Operating hours',
  'tms.ecus': 'ECUS code',
  'tms.open': 'Open',
  'tms.noPlaceMatch': 'No places match the filter',
  'tms.addPlace': 'Add place',
  'tms.addToll': 'Add toll station',
  'tms.viewOnlyShort': 'View only',
  'tms.ov.volume': 'Trips volume · 14 days',
  'tms.ov.perDay': 'trips/day',
  'tms.ov.outside': 'outside carriers',
  'tms.ov.byProgress': "Today's trips by progress",
  'tms.ov.trips': 'trips',
  'tms.ov.onTime': 'On time today',
  'tms.ov.todayTrips': "Today's trips · 22/Oct/2026",
  'tms.ov.thVehicle': 'Vehicle · driver',
  'tms.ov.thTrip': 'Trip · job',
  'tms.ov.thGps': 'GPS progress (7 steps)',
  'tms.ov.thDue': 'Due',
  'tms.ov.map': 'Map',
  'tms.ov.mapNote': 'VietMap · updated 1 min ago',
  'tms.ov.unassigned': 'Unassigned',
  'tms.ov.notOpen': 'This section is not open yet',
  'tms.ov.noTripsToday': 'No trips today',
  'tms.ov.retry': 'Retry',
  'tms.ov.urgent': 'urgent',
  'tms.td.ownTruck': 'own truck',
  'tms.td.sameTruck': 'Same truck',
  'tms.td.finish': 'Finish order',
  'tms.td.plan': 'Trip plan',
  'tms.td.stops': 'stops',
  'tms.td.remind': 'Remind driver',
  'tms.td.runTime': 'Run time',
  'tms.td.trackGps': 'Track GPS',
  'tms.td.mergeStop': 'Merge stop',
  'tms.td.earlyDrop': 'Request early drop / closing',
  'tms.td.idx': 'Operating metrics',
  'tms.td.calcOnFinish': 'computed on Finish',
  'tms.td.logLeg': 'Log leg',
  'tms.td.confirmAll': 'Confirm all',
  'tms.td.thEvent': 'Event',
  'tms.td.thSource': 'Source',
  'tms.td.phasePhotos': 'Photos by phase',
  'tms.td.photo': 'Photo',
  'tms.td.movePhase': 'Move phase',
  'tms.td.sendAll': 'Send all to driver',
  'tms.td.exportCsv': 'Export CSV',
  'tms.td.askJob': 'Ask job group',
  'tms.td.needConfirm': 'needs confirmation',
  'tms.td.depotLimit': 'Depot restrictions',
  'tms.td.call': 'Call',
  'tms.td.back': 'Back to dispatch',
  'tms.rp.viewAs': 'View as',
  'tms.rp.save': 'Save price',
  'tms.rp.inputs': 'Inputs',
  'tms.rp.cargo': 'Cargo type',
  'tms.rp.shape': 'Route type',
  'tms.rp.addStop': 'Add drop-off',
  'tms.rp.km': 'Route km',
  'tms.rp.kmBad': 'Enter km > 0',
  'tms.rp.empty': 'Empty ratio',
  'tms.rp.thStation': 'Station',
  'tms.rp.thSys': 'System',
  'tms.rp.thPass': 'Trips',
  'tms.rp.vetcTot': 'VETC total',
  'tms.rp.table': 'Active lookup table',
  'tms.rp.result': 'Result',
  'tms.rp.explain': 'Explain price',
  'tms.rp.totalCost': 'Total cost',
  'tms.rp.extraStop': 'Extra stop',
  'tms.rp.noMoney': "You don't have permission to view money.",
  'tms.rp.noTrf': "You don't have permission to view TRF prices.",
  'tms.rp.pickRoute': 'Pick a route',
  'tms.rp.close': 'Close',
  'tms.rp.ticketL5': 'Single-trip ticket L5',
  'tms.rp.amount': 'Amount',
  'tms.rp.vetcTariff': 'VETC tariff 10/2026',
});
